export default "__VITE_ASSET__CfNn$z0q__"